'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import { styled, css } from 'styled-components';
import { StoreBlockContext } from './StoreBlockContext';
import { Text } from '../Text';
import { Icon } from '../Icon';
import { Action } from '../Action';
const StyledHoursWrapper = styled.div.withConfig({
  componentId: "aui__sc-116y3q-0"
})(["max-height:", ";transition:max-height 0.25s ease-in-out;overflow:hidden;margin-top:calc(var(--aui-spacing-100) * -1);padding-left:var(--aui-spacing-400);& > *:first-child{padding-top:var(--aui-spacing-150);}display:flex;flex-direction:column;gap:var(--aui-spacing-050);"], ({
  $maxHeight
}) => `${$maxHeight}px`);
export const HoursWrapper = /*#__PURE__*/React.forwardRef(({
  children,
  maxHeight
}, fRef) => /*#__PURE__*/React.createElement(StyledHoursWrapper, {
  $maxHeight: maxHeight,
  ref: fRef
}, children));

// HoursToggle
const Toggle = styled.span.withConfig({
  componentId: "aui__sc-116y3q-1"
})(["position:relative;margin-left:calc(-1 * var(--aui-spacing-050));", " transition:transform 0.25s ease-in-out;", ";"], ({
  $size
}) => $size !== 'xl' && css(["margin-top:calc(-1 * var(--aui-spacing-050));margin-bottom:calc(-1 * var(--aui-spacing-050));"]), ({
  $isRotated
}) => $isRotated && 'transform: rotate(180deg)');
export const HoursToggle = ({
  isRotated,
  size,
  ...props
}) => /*#__PURE__*/React.createElement(Toggle, _extends({
  $isRotated: isRotated,
  $size: size
}, props), /*#__PURE__*/React.createElement(Action, _extends({
  size: "sm",
  state: "enabled",
  variant: "flat"
}, props), /*#__PURE__*/React.createElement(Icon.SSR, {
  src: "chevron-down",
  color: "var(--aui-on-surface)"
})));
export const Hours = styled.div.withConfig({
  componentId: "aui__sc-116y3q-2"
})(["display:grid;grid-template-columns:repeat(2,auto);gap:var(--aui-spacing-100);"]);
const Day = styled(Text).withConfig({
  componentId: "aui__sc-116y3q-3"
})(["padding-right:var(--aui-spacing-200);"]);
export const HoursRow = ({
  isToday,
  day,
  hours
}) => {
  const {
    size
  } = useContext(StoreBlockContext);
  const fontSize = {
    sm: 2,
    lg: 2,
    xl: 3
  }[size];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Day, {
    size: fontSize,
    weight: isToday ? 'heavy' : 'feather'
  }, day), /*#__PURE__*/React.createElement(Text, {
    size: fontSize
  }, hours));
};